import { AppColorStrings, ThemeType } from '../styles';

export const getColorFromTheme: ThemeGetterFn<AppColorStrings> = (props, color) => props.theme.colors[color];

type ThemeGetterFn<T> = (props: HasThemeProp, element: T) => string;
interface HasThemeProp {
  theme: ThemeType;
}
